<template>
    <v-card flat>
        <v-card-text>
            <v-container  grid-list-xl>            
                <v-layout row wrap>
                    <v-flex xs12>        
                        <v-btn color="info" @click="addNewBreak"  v-if="$can('do','POKO_Terapeuci_Edycja')" style="float:right">Dodaj przerwe</v-btn>
                    </v-flex>                    
                    <v-flex xs12>
                        <v-data-table
                            :headers="headers"
                            :items="therapistBreaks"
                            class="elevation-1"
                            :footer-props="{itemsPerPageOptions:[20,50,100,200]}" 
                            >
                            <template v-slot:item.day="{item}">
                                {{ getDayName(item.day) }}
                            </template>
                            <template v-slot:item.id="{item}">
                                <v-layout align-center>
                                    <v-icon small class="mr-2" @click="editBreak(item.id)" title="Edytuj" v-if="$can('do','POKO_Terapeuci_Edycja')">fa-edit</v-icon>
                                    <v-icon small @click="deleteBreak(item.id)" itle="Usuń" v-if="$can('do','POKO_Terapeuci_Edycja')">fa-trash-alt</v-icon>
                                </v-layout>        
                            </template>          
                        </v-data-table>                    
                    </v-flex>
                    <v-flex xs12>
                        <AddEditBreak :visible="showAddEditBreak" :breakData="breakData" :therapistID="therapistID" @close="closeAddPopup" @breaksSaved="breaksSaved" @breakUpdated="breakUpdated"/>
                    </v-flex>                    
                </v-layout>
            </v-container>
        </v-card-text>
    </v-card>    
</template>

<script>
import { therapistsService } from "@/services/";
import AddEditBreak from "./AddEditBreak";
import swal from "sweetalert";
export default {
    name: 'EditTherapistBreaks',
    data() {
        return {
            loading: false,    
            showAddEditBreak: false,
            breakData: {
                id: 0,
                day: 0,
                timeStart: '',
                timeEnd: ''
            },
            headers: [
                { text: 'Dzień', sortable: true, align: 'left', value: 'day'},
                { text: 'Początek', sortable: true, align: 'left', value: 'timeStart'},
                { text: 'Koniec', sortable: true, align: 'left', value: 'timeEnd'},                
                { text: 'Akcje', sortable: false, align: 'left', value: 'id'} 
            ],                   
        }
    },
    props: {
        breaks: Array,
        therapistID: Number
    },
    methods: {
        showError(text) {
            swal({
                title: "Błąd",
                text: text,
                icon: "warning",
                button: "OK"
            }).then(() => {
                this.loading = false;
            });
        },        
        editBreak(id)
        {
            let b = this.breaks.find(x=>x.id == id)
            if(b != null)
            {
                this.breakData.id = b.id
                this.breakData.day = b.day
                this.breakData.timeStart = b.timeStart
                this.breakData.timeEnd = b.timeEnd
                this.showAddEditBreak = true
            }
        },
        deleteBreak(id)
        {
            swal({
                    title: "Czy na pewno?",
                    text: "Czy na pewno chcesz usunąć tę przerwe?",
                    icon: "warning",
                    buttons: ["Nie", "Tak"],
                    dangerMode: true
                }).then(confirmed => {
                    if (confirmed) {
                    therapistsService
                        .DeleteTherapistBreak(id)
                        .then(resp => {
                            if (resp.data == null || !resp.data.success) {
                                throw "Błąd usuwania przerwy";
                            } else {        
                                var filtered = this.therapistBreaks.filter(x=> {
                                    return x.id != id
                                })                                             
                                this.therapistBreaks = filtered
                            }
                        })
                        .catch(() => {                        
                            this.showError("Nie można usunąć przerwy");
                        });
                    }
                });            
        },
        addNewBreak()
        {
            this.showAddEditBreak = true
        },
        getDayName(id)
        {
            switch(id)
            {
                case 1:
                    return 'Poniedziałek'                
                case 2:
                    return 'Wtorek';                
                case 3:
                    return 'Środa';                
                case 4:
                    return 'Czwartek';                
                case 5:
                    return 'Piątek';                
                case 6:
                    return 'Sobota';
                case 0:
                    return 'Niedziela';                
            }
        },
        closeAddPopup() {
            
            this.showAddEditBreak = false;
            this.breakData.id = 0
            this.breakData.day = 0
            this.breakData.timeStart = ''
            this.breakData.timeEnd = ''                
        },
        breaksSaved(event)
        {            
            this.breaks = event
        },
        breakUpdated(event)
        {
            //console.log(event)
            let b = this.breaks.find(x=>x.id == event.id)
            if(b != null)
            {                
                b.timeStart = event.timeStart
                b.timeEnd = event.timeEnd                
            }            
        }
    },
    computed: {
      therapistBreaks: {
          get: function() {
              return this.breaks
          },
          set: function(val) {
              this.$emit('update:breaks',val)              
          }
      },            
    },   
    components: {
        AddEditBreak
    } 
}
</script>

<style>

</style>
